import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Button, CircularProgress } from "@material-ui/core";
import {
    BackButton,
    FlexRowEnd,
    FlexRowSpaceBetween,
    Paper,
    Typography
} from "../../../../../../common/components/libs";
import { useStores } from "../../../../../../hooks";
import styled from "styled-components";
import { spacing } from "@material-ui/system";
import moment from "moment";
import { SnackbarType } from "../../../../../../stores/common";
import { useHistory, useParams } from "react-router-dom";
import { OrderStatus } from "../../../../../../services/orders/models";
import { localize } from "../../../../../../common/libs";
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from '@material-ui/lab';
import Helmet from "react-helmet";
import { Trans, useTranslation } from "react-i18next";
import style from "./style.module.css"
import BookingStoreContext from "../../store/context";
import { MenuType } from "../../../../../../services/menu/models";
import acceptedGreenIcon from './assets/acceptedGreen.svg'
import cancelIconRed from './assets/cancelRed.svg'
import { PaymentProviderType } from "../../../../../../services/general/models";
import rejectIcon from './assets/cancel.svg'
import acceptIcon from './assets/accept.svg'


const Spacer = styled.div(spacing);

const ViewBookingPage = () => {
    const { t } = useTranslation(["general", "bookings"]);
    const bookingsStore = useContext(BookingStoreContext);
    const { constantsStore, generalStore, bookingStore } = useStores();
    const [isReturningMoneyInProgress, setIsReturningMoneyInProgress] = useState(false);
    const history = useHistory();
    const filter = bookingsStore.filter;
    const { bookingId } = useParams<{ bookingId: string }>();
    const order = bookingsStore.currentOrder;

    useEffect(() => {
        let idNumber = parseInt(bookingId)
        bookingsStore.getBooking({ orderId: idNumber });
    }, [generalStore, bookingId, bookingsStore]);



    if (!order) {
        return null;
    }


    const returnMoney = async () => {
        setIsReturningMoneyInProgress(true);
        const id = {
            orderId: order.id
        }
        const returnResponse = await bookingsStore.returnPayment(id);
        if (!returnResponse) {
            const params: ({ type: SnackbarType, title: string, description?: string }) = {
                title: t("general:somethingWentWrong"),
                type: SnackbarType.error,
                description: t("general:tryAgain")
            }
            generalStore.showSnackbar(params);
        } else {
            bookingsStore.getBookings(filter);
            setIsReturningMoneyInProgress(false);
            generalStore.showSuccessSnackbar(t("bookings:refundMade"));
            history.push(`/stats/bookings/list`);
        }
    }

    const currencyFormatter = constantsStore.getCurrencyFormatter(order.totalPrice.currencyId);
    return (
        <div style={{ maxWidth: 600 }}>
            <Helmet title={t("bookings:orderDetails")}/>
            <BackButton to={"/stats/booking/list"}/>
            <Typography variant="h3" ml={2} mb={3}>
                <Trans i18nKey="bookings:bookingDetails" values={{bookingId: bookingId}}/>
            </Typography>
            <Paper className={style.commonDetails}>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("bookings:orderData")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {moment(order.createdAt).format("DD.MM.YYYY HH:mm")}
                    </Typography>
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("bookings:orderSum")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {currencyFormatter.toShowFormatted(order.totalPrice.price)}
                    </Typography>
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("bookings:paymentType")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {t(`bookings:paymentProviderType.${order.paymentDetails.type}`)}
                    </Typography>
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("bookings:paymentState")}
                    </Typography>
                    {(!order.paymentDetails.isPaid && order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.cloudpayments) &&
						<Typography component='h6' variant='body1' style={{ color: '#f57c00' }}>
                            {t("bookings:notPaid")}
						</Typography>
                    }
                    {(order.paymentDetails.isPaid && order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.cloudpayments) &&
						<Typography component='h6' variant='body1' style={{ color: '#388e3c' }}>
                            {t("bookings:paid")}
						</Typography>
                    }
                    {(order.status !== OrderStatus.canceledWithRefund && order.paymentDetails.type === PaymentProviderType.companyInvoice || order.paymentDetails.type === PaymentProviderType.offline || order.paymentDetails.type === PaymentProviderType.toBankCard) &&
						<Typography component='h6' variant='body1'>
							-
						</Typography>
                    }
                    {(order.status === OrderStatus.canceledWithRefund) &&
						<Typography component='h6' variant='body1' style={{ color: '#dc004e' }}>
                            {t("bookings:return")}
						</Typography>
                    }
                </div>
                <div className={style.detailsBlock}>
                    <Typography component='h6' variant='body2'>
                        {t("bookings:statusOfOrder")}
                    </Typography>
                    <Typography component='h6' variant='body1'>
                        {t(`bookings:orderStatus.${order.status}`)}
                    </Typography>
                </div>
                <Spacer mb={6}/>
                {(order.paymentDetails.isPaid && !isReturningMoneyInProgress && order.status !== OrderStatus.canceledWithRefund) &&
					<Button
						onClick={() => {
                            returnMoney()
                        }}
						color="primary"
					>
                        {t("bookings:returnMoney")}
					</Button>
                }
                {(isReturningMoneyInProgress) &&
					<Button
						color="primary"
						disabled
					>
						<CircularProgress
							size={25}
							color="secondary"
						/>
					</Button>
                }
            </Paper>


            <FlexRowSpaceBetween style={{ marginTop: 40 }}>
                <Typography component='h4' variant='h4' mt={0}>
                    {t("bookings:orderList")}
                </Typography>
              {/*  <Button color={'primary'}>
                    {t("bookings:confirmAll")}
                </Button>*/}
            </FlexRowSpaceBetween>
            <div>
                {order.items.map((orderItem) => {
                    const commonPart = orderItem.chosenMenuItemModifierSets.map((menuItemModifierSet) => {
                        return (
                            <div>
                                {menuItemModifierSet.chosenMenuItemModifiers.map((chosenMenuItemModifier) => {
                                    const modifier = menuItemModifierSet.data.modifiers.find(modifierItem => modifierItem.id === chosenMenuItemModifier.menuItemModifierId)
                                    return (
                                        <div className={style.commonDetails} style={{ marginLeft: 10 }}>
                                            <Typography component='h6' variant='subtitle1'
                                                        color='textSecondary'>
                                                {localize(modifier.data.name)} x {chosenMenuItemModifier.count}
                                            </Typography>
                                            <Typography component='h6' variant='subtitle1'
                                                        color='textSecondary'>
                                                {currencyFormatter.toShowFormatted(modifier.data.sellPrice.price)}
                                            </Typography>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    });
                    const totalItemPrice = currencyFormatter.toShowFormatted(orderItem.price.price * orderItem.itemsCount);
                    if (orderItem.type === MenuType.regular) {
                        const photo = orderItem.menuItem.data.media.length > 0 && orderItem.menuItem.data.media[0].preview;

                        return (
                            <Paper style={{ marginBottom: "10px", padding: 15 }}>
                                {
                                    photo ? <img src={photo} alt="" style={{ width: 100 }}/> : <div></div>
                                }
                                <div className={style.detailsBlock}>
                                    <Typography component='h6' variant='body1'>
                                        {localize(orderItem.menuItem.data.name)} x {orderItem.itemsCount} = {totalItemPrice}
                                    </Typography>
                                    <Typography component='h6' variant='body1'>
                                        {currencyFormatter.toShowFormatted(orderItem.price.price)}
                                    </Typography>
                                </div>
                                {commonPart}

                            </Paper>
                        )
                    } else if (orderItem.type === MenuType.booking) {
                        const photo = orderItem.menuBookingItem.data.media.length > 0 && orderItem.menuBookingItem.data.media[0].preview;

                        return (
                            <Paper style={{ marginBottom: "10px", padding: 15 }}>
                                <div style={{ display: "flex", alignItems: 'flex-start', }}>
                                    {
                                        photo ? <img src={photo} alt="" style={{ width: 80, marginRight: 15 }}/> :
                                            <div></div>
                                    }
                                    <div className={style.detailsBlock}>
                                        <div>
                                            <Typography component='h6' variant='h6'>
                                                {localize(orderItem.menuBookingItem.data.name)}
                                            </Typography>
                                            <Typography component='h6' variant='body1'>
                                                {currencyFormatter.toShowFormatted(orderItem.price.price)} x {orderItem.itemsCount} шт.
                                                = {totalItemPrice}
                                            </Typography>
                                            <div>
                                                {orderItem.chosenMenuBookingItemSlots.map(slot => {
                                                    return <Typography component='p' variant='body1'>
                                                        {moment(slot.fromDate).format("HH:mm")} - {moment(slot.toDate).format("HH:mm")}
                                                    </Typography>
                                                })}
                                            </div>

                                        </div>
                                        {order.status === OrderStatus.accepted &&
                                        <div>

                                                <div style={{ display: 'flex', alignItems: "center",  }}>
                                                    <img src={acceptedGreenIcon} alt="" className={style.bookingItemIcons}/>
                                                    {t("bookings:confirmed")}
                                                </div>
                                        </div>
                                        }
                                        {order.status  === OrderStatus.canceled &&
                                        <div>

                                                <div style={{ display: 'flex', alignItems: "center" }}>
                                                    <img src={cancelIconRed} alt="" className={style.bookingItemIcons}/>
                                                    {t("bookings:canceled")}
                                                </div>
                                        </div>
                                        }
                                    </div>
                                    {commonPart}
                                </div>
                            </Paper>
                        )
                    }

                })
                }
            </div>

            {bookingsStore.currentOrder.status === OrderStatus.new && <Paper style={{ marginTop: 20, padding: 10 }}>
				<FlexRowSpaceBetween style={{ alignItems: 'center' }}>
					<Typography variant={'h6'}>
                        {t("bookings:bookingConfirmation")}
					</Typography>
					<FlexRowEnd>

						<Button
							onClick={async ()=>{
                                const data = {
                                    bookingOrderId: order.id,
                                    menuId: order.menuBookingId,
                                    newStatus: OrderStatus.canceled
                                }
                                await bookingStore.updateBookingOrderStatus(data).then(()=>  {bookingsStore.getBooking({ orderId: order?.id })})
                            }}>
							<img src={rejectIcon} className={style.buttonIcons} alt=""/>
                            {t("general:cancel")}
						</Button>
						<Button color={'primary'}
								onClick={async ()=>{
                                    const data = {
                                        bookingOrderId: order.id,
                                        menuId: order.menuBookingId,
                                        newStatus: OrderStatus.accepted
                                    }
                                    await bookingStore.updateBookingOrderStatus(data).then(()=> {bookingsStore.getBooking({ orderId: order?.id })})
                                }
                                }>
							<img src={acceptIcon} alt="" className={style.buttonIcons}/>
                            {t("general:confirm")}
						</Button>
					</FlexRowEnd>
				</FlexRowSpaceBetween>
			</Paper>}


            <Typography component='h4' variant='h4' mb={2} mt={10}>
                {t("bookings:orderHistory")}
            </Typography>
            <Paper className={style.history}>
                {order.statusHistory.map((statusDetail, index) => {
                        return (
                            <div style={{ margin: "15px" }}>
                                <Timeline align='alternate'>
                                    <TimelineItem>
                                        <TimelineOppositeContent>
                                            {moment(statusDetail.changedAt).format("DD.MM.YYYY HH:mm")}
                                        </TimelineOppositeContent>

                                        <TimelineSeparator>
                                            <TimelineDot/>
                                            {
                                                order.statusHistory.length - 1 > index && <TimelineConnector/>
                                            }
                                        </TimelineSeparator>

                                        <TimelineContent>
                                            {t(`bookings:orderStatus.${statusDetail.toStatus}`)}
                                        </TimelineContent>
                                    </TimelineItem>
                                </Timeline>
                            </div>
                        )
                    }
                )}
            </Paper>
        </div>
    );

}

export default observer(ViewBookingPage);
